<script>
	import { action } from "../api";

	export let player = {};
	export let showSolution = false;

	let name = player.name;

	const changeName = ({ target: { value } }) => {
		action("changeName", value);
	}
</script>

<div class={"container" + (player.isYou ? " you" : "")}>
	<div class="player">
		<div class={"name" + (player.solved ? " solved" : "")}>
			{#if player.isYou}
				<input
					class={"input" + (player.solved ? " solved" : "")}
					style="width: {name.length + 2}ch"
					bind:value={name}
					on:change={changeName}
				/>
			{:else}
				{player.name}
			{/if}
		</div>
		<div class={"points" + (player.solved ? " solved" : "")}> {player.points} </div>
	</div>
	{#if showSolution}
		{#if player.solution && typeof player.solution ===  "string"}
			<div class="solution"> /{player.solution}/{player.flags} </div>
		{/if}
		{#if player.solution && player.solution.correctAnswers && player.solution.falseAnswers}
			<div class="readAnswersContainer">
				<div class="readAnswers">
					{#each player.solution.correctAnswers as { text, matched }}
						<span class={matched ? "matched" : "nonMatched"}>{text}</span>
					{/each}
				 </div>
				<div class="readAnswers">
					{#each player.solution.falseAnswers as { text, matched }}
						<span class={matched ? "matched" : "nonMatched"}>{text}</span>
					{/each}
				 </div>
			</div>
		{/if}
	{/if}
</div>

<style>
	.container {
		display: flex;
		justify-content: space-around;
		flex-direction: column;
		border: solid;
		border-width: 2px;
		border-color: black;

		padding: 20px;
		margin-bottom: 10px;
	}

	.player {
		display: flex;
		justify-content: space-around;
		margin-bottom: 10px;
	}

	.you {
		border-color: var(--gold);
	}

	.solved {
		color: var(--green);
	}

	.name {
		font-size: 1.2em;
		width: 80%;
	}

	.points {
		width: 20%;
	}

	input {
		font-size: 20px;
		border: none;
		background-color: transparent;
		height: 20px;
		margin: 0;
	}

	input:focus{
	    outline: none;
	}

	.points {
		font-size: 20px;
	}

	.solution {
		font-family: var(--font-family-mono);
	}

	.readAnswersContainer {
		display: flex;
		justify-content: space-around;
	}

	.readAnswers {
	    display: flex;
   		flex-direction: column;
	}

	.matched {
		color: var(--green);
	}

	.nonMatched {
		color: var(--red);
	}
</style>
